import { render, staticRenderFns } from "./AccountBlockedError.vue?vue&type=template&id=2a8b8b7e&"
import script from "./AccountBlockedError.vue?vue&type=script&lang=js&"
export * from "./AccountBlockedError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports